import React from 'react';
import PropTypes from 'prop-types';

import SelectWithLabelV2 from '../../../../components/composite/FormSets/SelectWithLabelV2/SelectWithLabelV2';
import { countries } from '../../../../utils/country-utils';
import { setFieldAndValidate } from '../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../utils/validation-utils';

const CountrySelectorControlSet = ({ countryOrRegion, setCountryOrRegion }) => (
  <SelectWithLabelV2
    id="countryOrRegion"
    label="Country"
    value={countryOrRegion.value}
    options={
        countries.map(
          (c) => ({
            disabled: c.key === 'disabled',
            display: c.value,
            key: c.key,
            value: c.value === 'Please Select Your Country' || c.value === '──────────'
              ? ''
              : c.value,
          }),
        )
      }
    errorMsg={countryOrRegion.error}
    onChange={({ target: { value } }) => setFieldAndValidate(countryOrRegion, setCountryOrRegion, value, userFieldSchemas.countryOrRegion)}
  />
);

CountrySelectorControlSet.propTypes = {
  countryOrRegion: PropTypes.shape({
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
  }).isRequired,
  setCountryOrRegion: PropTypes.func.isRequired,
};

export default CountrySelectorControlSet;
